import React from 'react';
import {Field} from 'formik';
import {TextField, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";

function AgenceDataField({values, errors, handleChange, handleBlur}) {
    return (
        <Grid container size={12} spacing={1} className={"sectionContainer"}>
            <Grid size={12}>
                <Typography variant={"h5"} className={"sectionHeader"}>Informations Agence</Typography>
            </Grid>

            {/* LIBELLE */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Libellé <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field type="text" value={values.libelle}>
                        {({field, form}) => (
                            <TextField
                                error={Boolean(form.errors.libelle && form.touched.libelle)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.libelle}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="libelle"
                                label="Libellé"
                                autoFocus
                                helperText={
                                    form.errors.libelle &&
                                    form.touched.libelle &&
                                    String(form.errors.libelle)
                                }
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* CODE COULEUR */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Couleur <span className="asterix">*</span>
                </Grid>
                <Grid size={2}>
                    <Field type="color" value={values.codeCouleur}>
                        {({field, form}) => (
                            <TextField
                                error={Boolean(form.errors.codeCouleur && form.touched.codeCouleur)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.codeCouleur}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="codeCouleur"
                                label="Couleur"
                                type="color"
                                slotProps={{
                                    input: {
                                        style: {height: "3rem", padding: 0, width: "5rem"}
                                    },
                                    inputLabel: {shrink: true}
                                }}
                                helperText={
                                    form.errors.codeCouleur &&
                                    form.touched.codeCouleur &&
                                    String(form.errors.codeCouleur)
                                }
                            />
                        )}
                    </Field>
                </Grid>
                <Grid size={4}>
                    <span style={{
                        display: 'inline-block',
                        backgroundColor: values.codeCouleur,
                        borderRadius: '4px',
                        padding: '4px 12px',
                        color: '#fff',
                        fontWeight: 'bold',
                        marginLeft: '1rem',
                        textShadow: '0 1px 2px rgba(0,0,0,0.4)'
                    }}>
                        {values.libelle || 'Aperçu'}
                    </span>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default AgenceDataField;
